import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';

import type { ScheduleRunItemAction } from '@nucleus-commerce/api-client/admin';

import { schedulesApi } from '../api/schedules-api';

import { scheduleKeys } from './schedule-keys';

const PAGE = 50;

export interface RunItemFilters {
  storeId: string | null;
  action: ScheduleRunItemAction | null;
}

/** What a run did per store and product, filtered by store and action, a page at a time. */
export function useScheduleRunItems(
  id: string,
  runId: string | null,
  filters: RunItemFilters,
  live: boolean,
) {
  const params = {
    limit: PAGE,
    ...(filters.storeId ? { storeId: filters.storeId } : {}),
    ...(filters.action ? { action: filters.action } : {}),
  };
  return useInfiniteQuery({
    queryKey: scheduleKeys.runItems(id, runId ?? '', params),
    queryFn: ({ pageParam }) =>
      schedulesApi.runItems(id, runId ?? '', {
        ...params,
        ...(pageParam ? { cursor: pageParam } : {}),
      }),
    enabled: runId !== null,
    initialPageParam: null as string | null,
    getNextPageParam: (page) => page.nextCursor,
    placeholderData: keepPreviousData,
    refetchInterval: live ? 3_000 : false,
  });
}
